import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import axiosInstance from "../utils/axiosInstance";
import PayNowForm from "./PayNowForm";

const PaymentButton = ({ file, setRefreshDetails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasEnoughtCredits, setHasEnoughCredits] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user.credit_balance >= file.price) {
      setHasEnoughCredits(true);
    } else {
      setHasEnoughCredits(false);
    }
  }, []);

  const handlePaymentClick = async () => {
    setIsModalOpen(true);
  };

  const confirmAndPay = async () => {
    try {
      setLoading(true);
      await axiosInstance.put(`/files/${file.id}/confirm-and-pay`);
      setRefreshDetails(true);
    } catch (error) {
      console.error("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {file.price_status === "UNPAID" &&
        file.status !== "CANCELED" &&
        file.status !== "REFUNDED" && (
          <div className="payment-buttons mt-4">
            <button
              onClick={handlePaymentClick}
              className="btn btn-credits bg-green-500 text-white px-4 py-2 flex items-center rounded-md gap-2 mr-2"
              disabled={loading}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M3 4a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm5 4a1 1 0 000 2h4a1 1 0 000-2H8z"
                  clipRule="evenodd"
                />
              </svg>
              {hasEnoughtCredits ? "Confirm & Pay" : "Buy Credits & Pay"}
            </button>
          </div>
        )}

      {/* Modal for incomplete files */}
      {isModalOpen && (
        <div className="modal fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="modal-content bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg text-gray-900 dark:text-gray-100">
            {!hasEnoughtCredits ? (
              <>
                <h2 className="text-lg font-bold mb-3">
                  You don't have enough credits
                </h2>
                <p className="mb-4">
                  Click below button to buy credits for getting the file.
                </p>
                <div className="text-center">
                  <PayNowForm userId={user.id} fileId={file.id} />
                </div>
                <div className="text-right">
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="mt-4 px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                  >
                    Close
                  </button>
                </div>
              </>
            ) : (
              <>
                <h2 className="text-lg font-bold mb-2">Confirm Payment?</h2>
                <p className="mb-2 text-sm">
                  <strong className="text-red-500">Important:</strong> If tool
                  doesn't support checksum, <br /> please correct the checksum
                  before writing.
                </p>
                <div className="text-right">
                  <button
                    onClick={() => confirmAndPay()}
                    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md mr-2 hover:bg-blue-600 disabled:opacity-50"
                    disabled={loading}
                  >
                    {loading ? "Paying..." : "Yes"}
                  </button>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="mt-4 px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 disabled:opacity-50"
                    disabled={loading}
                  >
                    No
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentButton;
